var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLineChart = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 2.5H15.8333C16.75 2.5 17.5 3.24167 17.5 4.16667V12.4368H16.1728L14.9476 11.3586C14.682 11.1249 14.2888 11.1095 14.0057 11.3218L13.5071 11.6958L12.5014 10.0867C12.3807 9.89366 12.1786 9.76615 11.9524 9.74038C11.8145 9.72468 11.6769 9.74781 11.5539 9.80471L10.8264 8.16778C10.7264 7.94284 10.5221 7.78158 10.2801 7.73665C10.11 7.70507 9.93673 7.73377 9.78832 7.814L8.80043 5.83824C8.65798 5.55334 8.35057 5.39008 8.03476 5.43162C7.71896 5.47315 7.46421 5.71034 7.40027 6.02239L6.22206 11.7721L5.75222 11.3586C5.51585 11.1506 5.17443 11.1131 4.89854 11.2649L2.76785 12.4368H2.5V4.16667C2.5 3.24167 3.24167 2.5 4.16667 2.5Z",
    fill: "url(#paint0_linear_676_498)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.9311V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H15.8333C16.2754 17.5 16.6993 17.3244 17.0118 17.0118C17.3244 16.6993 17.5 16.2754 17.5 15.8333V13.9311H15.8908C15.7091 13.9311 15.5336 13.8649 15.3972 13.7448L14.4164 12.8816L13.7529 13.3793C13.5855 13.5048 13.3733 13.5544 13.1676 13.516C12.962 13.4777 12.7819 13.3549 12.671 13.1775L11.7264 11.6661C11.5629 11.7825 11.3575 11.8293 11.1567 11.792C10.9147 11.7471 10.7103 11.5858 10.6104 11.3609L9.88284 9.72393C9.74924 9.78577 9.59846 9.80762 9.44929 9.78341C9.21223 9.74494 9.00812 9.59486 8.90071 9.38005L8.43032 8.43926L7.42732 13.334C7.37385 13.5949 7.18547 13.8077 6.9329 13.8923C6.68033 13.977 6.40178 13.9208 6.20181 13.7448L5.15893 12.827L3.34572 13.8244C3.21843 13.8944 3.07552 13.9311 2.93024 13.9311H2.5Z",
    fill: "url(#paint0_linear_676_498)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_676_498",
    x1: 5.23057,
    y1: -12.645,
    x2: 31.5261,
    y2: 5.61303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536953,
    stopColor: "#FF695C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF475E"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLineChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/line_chart.cf8b643466bcec72ba7f5dc37f5f1a65.svg";